var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.option)?_c('div',{staticClass:"issue_status"},[_c('div',{staticClass:"avatar"},[(_vm.avatar)?_c('img',{attrs:{"src":_vm._f("avatarUrl")(_vm.option)}}):_vm._e()]),_c('div',[_vm._v(_vm._s(_vm._f("fullName")(_vm.option)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }